//we use this id for create unic name for multiselect
//only used for the ac selection
var radioUnicId = 0

export function sale_vs_item(id, idItem){

	const showCostInput = document.querySelector("#saleDeleted-fullcont #showcost");
	let check_showcost = showCostInput ? showCostInput.checked : false;
	let class_dn       = "dn";
	let width_main     = "48%";
	let width_detail   = "50%";
	let class_c        = "c25";
	let class_c_qty    = "c20";

	if (check_showcost) {
		class_dn     = "";
		width_main   = "25%";
		width_detail = "73%";
		class_c      = "c16";
		class_c_qty  = "c14";
	}

	let parsedId = "";
	if (idItem && idItem !== "" && idItem !== "[]") {
		const itemData = typeof idItem === 'string' ? JSON.parse(idItem) : idItem;
		parsedId = itemData[0] ? itemData[0].id : "";

	} 


	radioUnicId++
	return `

	<div class="line line-${id} " lineId="${id}"   > 

      <div class="removeLine" data-detail='{"click": [  {"dest":"ripple"}, {"dest":"multitable", "act":"removeLine" },
	  													{"dest":"saleDeleted", "elem":"fullcont",  "act":"calculateGrandTotal"}  ] }'>
   	 </div>  

		<!-- quitar clase dn para item info -->
		<div class="btn-item-info " data-detail='{"click": [  {"dest":"ripple"},{"dest":"item", "elem":"quickview", "act":"getExtraData", "idItem":"${parsedId}", "from":"saleDeleted" } ] }'></div>  
		
		<!-- agregar style="margin-left:24px;" para item info -->
	    <div class="row"  style="margin-left:24px;">
	 
		    <div  class="itemname" style="width: ${width_main};" >

				<div class="row">
					<div class="c100">

						<div class="textfield   textfield-autocomplete textfield-autocomplete-mini  purchase_vs_itemId" id="saleDeleted_form_item_mt_${radioUnicId}" selected = '[]'  max = '1'>

							<input autocomplete="off"  class= 'elem' type="text" 
								data-detail='{
								"key": [   {"dest":"textfield",    "act":"typing" }, 
											{"dest":"autocomplete", "act":"typing",  "entity": "purchase_vs_item", "mainFilter": ["item.name","item.code","purchase.code"], "parent": "saleDeleted_form_item_mt_${radioUnicId}"   }],
								"click": [ {"dest":"autocomplete", "act":"click",   "entity": "purchase_vs_item", "mainFilter": ["item.name","item.code","purchase.code"], "parent": "saleDeleted_form_item_mt_${radioUnicId}"   }]
								}' >
								
							<div class="chip-cont"></div>
							<!-- otherField is used for autocomplete other fields, different than id and displayText -->  
							<div class="dn otherField" data-detail='{"click": [ {"dest":"saleDeleted", "elem":"fullcont",  "act":"otherFieldItem" ,"id_ac":"${radioUnicId}" } ] }' ></div> 

						</div> <!-- textfield --> 

					</div><!-- c100 --> 
				</div>

			</div>



			<div class="itemdetail" style="width: ${width_detail};" >
   
				<div class="row">
					<div class="c16">

						<div class="textfield textfield-disabled textfield-mini selling_type"  >

							<input autocomplete="off"  class= 'elem' type="text" placeholder="Type" tabindex="-1"
							data-detail='{"key":   [ {"dest":"textfield", "act":"typing"  }]}' readonly>

						</div><!-- textfield -->  

					</div><!-- c25 --> 

					<div class="${class_c_qty}">
						<div class="textfield textfield-mini qty"  >

							<input autocomplete="off"  class= 'elem' type="number"  placeholder="qty"  step="1" min="0"
							data-detail='{"key": [{"dest":"textfield", "act":"typing"}] }' >

						</div><!-- textfield -->  

					</div><!-- c25 -->

					<div class="c14 dn_return ${class_dn}">

						<div class="textfield textfield-mini textfield-disabled returned_qty"  >

							<input autocomplete="off"  class= 'elem' type="text" 
							data-detail='{"key":   [ {"dest":"textfield", "act":"typing"  }] }' readonly>
							
						</div><!-- textfield -->  

					</div><!-- c25 -->

					<div class="c20 ${class_dn} dn_cost_vs_profit">

						<div class="textfield textfield-mini textfield-cash  textfield-disabled cost_vs_profit"  >

							<input autocomplete="off"  class= 'elem' type="text" 
							data-detail='{"key":   [ {"dest":"textfield", "act":"typing"  }] }' style="background-color: #f2c2cb;" readonly>
							
						</div><!-- textfield -->  

					</div><!-- c25 -->

					<div class="c20 dn">

						<div class="textfield textfield-mini textfield-cash  textfield-disabled cost"  >

							<input autocomplete="off"  class= 'elem' type="text" 
							data-detail='{"key":   [ {"dest":"textfield", "act":"typing"  }] }' style="background-color: #f2c2cb;" readonly>
							
						</div><!-- textfield -->  

					</div><!-- c25 -->

					<div class="c20 dn">

						<div class="textfield textfield-mini textfield-cash  textfield-disabled cogs_row_amount"  >

							<input autocomplete="off"  class= 'elem' type="text" 
							data-detail='{"key":   [ {"dest":"textfield", "act":"typing"  }] }' style="background-color: #f2c2cb;" readonly>
							
						</div><!-- textfield -->  

					</div><!-- c25 -->
					
					<div class="c16">
						<div class="textfield textfield-cash textfield-mini price"  >

							<input autocomplete="off"  class= 'elem' type="number" placeholder="price"   step="1" min="0"
							data-detail='{"key": [{"dest":"textfield", "act":"typing"}] }' >

						</div><!-- textfield -->  

					</div><!-- c25 -->



					<div class="c16">
						<div class="textfield textfield-cash  textfield-mini total"  >

							<input autocomplete="off"  class= 'elem' type="number" placeholder="Total Price"  step="1" min="0" 
							data-detail='{"key": [{"dest":"textfield", "act":"typing"}] }'>

						</div><!-- textfield -->  

					</div><!-- c25 -->

				</div>

			</div>

	    </div><!-- row -->
	</div><!-- line -->  
	`

}

var item_lost = 0
export function sale_vs_return(id){
	item_lost++
	return `

	<div class="line line-${id} " lineId="${id}" id="saleDeleted_form_lost_mt_${item_lost}"> 

    	<div class="removeLine" data-detail='{"click": [  {"dest":"ripple"}, {"dest":"multitable", "act":"removeLine" }  ] }'>
   		</div>  

		<div class="row">

			<div style="width:  40%;" >
				<div class="row">

					<div class="c100">
						<div class="textfield textfield-desk textfield-autocomplete textfield-autocomplete-mini sale_vs_itemId returns" id="saleDeleted_form_sale_vs_itemId_${item_lost}" selected = '[]'  max = '1' >

								<input class= 'elem' type="text" placeholder="" data-detail='{
									"key": [   
									{"dest":"textfield",    "act":"typing" }],
									"click": [ 
									{"dest":"saleDeleted", "act":"beforeAutocomplete", "elem":"fullcont",   "entity": "sale_vs_return", "mainFilter": ["item.name","item.code"], "parent": "saleDeleted_form_sale_vs_itemId_${item_lost}"   }]
								}' >

								<div class="chip-cont"> </div>
								<div class="dn otherField" data-detail='{"click": [ {"dest":"saleDeleted", "elem":"fullcont",  "act":"otherFieldItemLost" } ] }' ></div> 

							</div><!-- textfield -->
					</div>

	          	</div>
			</div>

			<div style="width:  57%;" >
				<div class="row">
					
					<div class="c16">
							<div class="textfield textfield-mini lost_qty"  >
								<input autocomplete="off"  class= 'elem' type="number"  placeholder="qty"  step="1" min="0"
								data-detail='{"key": [{"dest":"textfield", "act":"typing"}] }' >

							</div><!-- textfield -->  
					</div><!-- c16 -->

					<div class="c16">
							<div class="textfield textfield-cash textfield-mini textfield-disabled lost_price"  >

								<input autocomplete="off"  class= 'elem' type="text" placeholder="price"   step="1" min="0"
								data-detail='{"key":   [ {"dest":"textfield", "act":"typing"  }] }' >

							</div><!-- textfield -->  
					</div><!-- c16 -->
					

					<div class="c25">
						<div class="textfield textfield-date  textfield-desk  textfield-mini date"  >
							<input autocomplete="off"  class= 'elem' type="date"   value = '' 
									data-detail='{"click": [ {"dest":"textfield", "act":"focused"  }], 
													"key": [ {"dest":"textfield", "act":"typing"  }, 
												{"dest":"textfield", "act":"validator", "validator": "date"  }],
													"change": [{"dest":"textfield", "act":"validator", "validator": "date"  }] }'  >

							<div class="indicador"></div>
							<div class="label"></div> 
						</div><!-- textfield -->  
					</div>



					<div class="c33" style="width:  39%;">
						<div class="textfield textfield-mini notes" >

							<input autocomplete="off" placeholder="" class= 'elem' type="text"
													data-detail='{ "key":   [ {"dest":"textfield","act":"typing"  }] }' >

						</div><!-- textfield -->
					</div>
				</div>
			</div>
	          	
		</div><!-- row -->

	</div><!-- line -->  
	`

}
